import $ from "jquery";
import "../../../node_modules/slick-carousel/slick/slick";

const serviceSliderPlayer = () => {
  const init = () => {
    serviceSlider();
  };

  const serviceSlider = () => {
    const el = {
      sliderImage: "div.serviceSlider-image-slick",
      sliderContent: "div.serviceSlider-content-slick",
    };

    const imageSetting = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".serviceSlider-content-slick",
      pauseOnHover: true,
    };

    const contentSetting = {
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      asNavFor: ".serviceSlider-image-slick",
      dots: false,
      prevArrow: false,
      nextArrow: $(el.sliderImage),
      pauseOnHover: true,
    };

    $(el.sliderImage).slick(imageSetting);
    $(el.sliderContent).slick(contentSetting);
  };

  init();
};

try {
  serviceSliderPlayer();
} catch (error) {
  console.log(error);
}
